// src/config/axios.js

import axios from 'axios';

// Get the current host for multi-tenant support
const getCurrentBaseUrl = () => {
    const host = window.location.hostname;
    const port = window.location.port ? `:${window.location.port}` : '';
    const protocol = window.location.protocol;
    
    // For development, when accessing from localhost, use a default tenant
    if (host === 'localhost' && !process.env.REACT_APP_API_URL) {
        console.warn('Accessing from localhost - please use tenant subdomain (e.g., shri.localhost:3000)');
    }
    
    // If we're on port 3000 (React dev server), the API is on port 8000 (Laravel dev server)
    const apiPort = window.location.port === '3000' ? ':8000' : port;
    
    // Always use dynamic URL based on current hostname
    const baseUrl = `${protocol}//${host}${apiPort}/api`;
    return baseUrl;
};

// Create axios instance with default config
const axiosInstance = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    withCredentials: true, // Important for Laravel Sanctum/session auth
});

// Request interceptor to add auth token and set base URL
axiosInstance.interceptors.request.use(
    (config) => {
        // Set base URL dynamically
        config.baseURL = getCurrentBaseUrl();
        
        // Add auth token
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors
axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            // Clear auth data and redirect to login
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
            localStorage.removeItem('isAuthenticated');
            window.location.href = '/app/login';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;